import React, { useState, useEffect, useRef } from 'react';
import './DetailPageHeroVideo.css'; // Reuse the same CSS

const DetailPageHeroYouTube = ({ videoId, lazy = true }) => {
  const [isVisible, setIsVisible] = useState(!lazy);
  const containerRef = useRef();

  useEffect(() => {
    if (!lazy) {
      setIsVisible(true);
      return;
    }

    const node = containerRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { 
        rootMargin: '100px 0px',
        threshold: 0.1 
      }
    );

    if (node) {
      observer.observe(node);
    }

    return () => {
      if (observer && node) {
        observer.unobserve(node);
      }
    };
  }, [lazy]);

  return (
    <div 
      className="detail-page-hero-video-container"
      ref={containerRef}
      style={{ 
        position: 'relative',
        marginTop: '40px'
      }}
    >
      {isVisible && (
        <iframe
          className="detail-page-hero-video"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
          title="YouTube video player"
          style={{ border: 'none' }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      )}
    </div>
  );
};

export default DetailPageHeroYouTube; 